// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

const CreditBureauReportActionTypes = {
	/** ***************** FETCH CREDIT BUREAU REPORT START *********************** */
	GET_CREDIT_BUREAU_REPORT_LIST_START: 'get_credit_bureau_report_start',
	GET_CREDIT_BUREAU_REPORT_LIST_SUCCESS: 'get_credit_bureau_report_success',
	GET_CREDIT_BUREAU_REPORT_LIST_FAILURE: 'get_credit_bureau_report_failure',
	GET_CREDIT_BUREAU_REPORT_LIST_RESPONSE_RESET: 'get_credit_bureau_report_response_reset',
	GET_CREDIT_BUREAU_REPORT_LIST_RESPONSE_CHANGED: 'get_credit_bureau_report_response_changed',
	/** ***************** FETCH CREDIT BUREAU REPORT END *********************** */
};

export default CreditBureauReportActionTypes;
